var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVppa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-281.2,-1403.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,-638.978,-301.057)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.18587,6.48236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.806248,0,0,0.452573,689.194,306.392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.383,
    cy: 1395.21,
    r: 70.807,
    style: {
      fill: "rgb(255,152,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.142294,0,0,0.0804006,776.45,839.913)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.13769e-16,1.31825e-16,-1,2163.81,2415.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1245.9,1116.71L1247.42,963.294L864.121,963.294L864.121,1363.6L966.649,1466.25L1247.42,1466.25",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-5.73255,0.0884179,-0.0856217,-5.19787,6873.54,2817.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.946,375.225L983.944,357.152L967.825,356.885M967.8,357.001L983.903,375.225",
    style: {
      fill: "rgb(241,152,5)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.383474,0,0,0.201289,789.641,647.091)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "331.364px",
    y: "1433.22px",
    style: {
      fontFamily: "'Helvetica-Bold', 'Helvetica'",
      fontWeight: 700,
      fontSize: "73.452px",
      fill: "rgb(255,152,0)"
    }
  }, "$")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.988659,0.148718,-0.661011,0.536513,406.973,796.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.91,111.01L603.521,85.276",
    style: {
      fill: "none",
      stroke: "rgb(255,152,0)",
      strokeWidth: "3.2px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.290772,0,0,0.152629,884.648,686.754)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "116.953px",
    y: "1733.98px",
    style: {
      fontFamily: "'Helvetica-Bold', 'Helvetica'",
      fontWeight: 700,
      fontSize: "73.452px",
      fill: "rgb(255,152,0)"
    }
  }, "C02"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVppa);
export default __webpack_public_path__ + "static/media/vppa.374e65ab65fe64e0c26209a0428339df.svg";
export { ForwardRef as ReactComponent };